import React from "react";
import { Header } from "../Layout/Header";

const NoSidebarLayout: React.FC<{classOverrides?:string}> = ({ children, classOverrides }) => {
  const defaultClass = "w-full sm:w-2/3 md:w-2/3 lg:w-1/3 xl:w-1/4 flex justify-center m-auto p-2 min-h-screen";
  return (
    <div>
      <Header />
      <div className={classOverrides||defaultClass} style={{minHeight: "calc(100vh - 64px)"}}>
        <div className="w-full">
          {typeof children === "function" ? children() : children}
        </div>
      </div>
    </div>
  );
};

export default NoSidebarLayout;
